export enum FriendType {
  Following = 'following',
  Follower = 'follower',
}
